import { api } from "../lib/axios";

import type { VectorEmbeddingModel } from "../types/vector";
import type { ApiData } from "./apiData";
import type { VectorApiParams } from "./createNamespace";

interface DeleteNamespaceBody {
    embeddingModelName: VectorEmbeddingModel
}

interface DeleteNamespaceData {
    message: string
}

type DeleteNamesapceResponse = ApiData<DeleteNamespaceData>

async function deleteNamespace({
    body, params
}: {
    body: DeleteNamespaceBody,
    params: VectorApiParams
}) {
    const response = await api.delete(
        '/vector/delete-nameSpace',
        { data: body, params  }
    )

    return response.data
}

export {
    deleteNamespace,
    type DeleteNamespaceBody,
    type DeleteNamesapceResponse,
}